export default "__VITE_ASSET__c0f2477c__"